/**
 * Created by mac on 12/7/20
 */

const Map2d = function (slot, groundMap, options) {
    cleverapps.EventEmitter.call(this);

    Map2d.currentMap = this;

    this.slot = slot;

    this.lastActionPlayer = 0;
    this.actionPlayers = {};

    this.counter = new Counter();

    this.heroes = [];
    this.cinematics = [];

    this.regions = {};
    Object.keys(options.regions || {}).forEach((regionName) => {
        this.regions[regionName] = options.regions[regionName];
    });

    options = options || {};
    this.field = options.field;
    this.families = options.families;

    this.unitsSkin = options.units;
    this.tilesSkin = options.tiles;
    this.background = options.background || {};

    if (Map2d.resetChessLayerVisible) {
        Map2d.resetChessLayerVisible();
    }

    this.visibleBox = this.prepareVisibleBox(cleverapps.config.editorMode ? Map2d.getEditorVisibleBox(options.visibleBox) : options.visibleBox || Map2d.VISIBLE_BOX);
    this.tilesVisibleRectFrame = options.tilesVisibleRectFrame || Map2d.TILES_VISIBLE_RECT_FRAME;
    this.waterBorder = options.waterBorder !== undefined ? options.waterBorder : Map2d.WATER_BORDER;

    this.decorators = new Map2dDecorators(options.decorators || []);

    if (cleverapps.meta.getSelectedLocation().locationConfig.usePathIndicator) {
        this.pathIndicator = new PathIndicator(this);
    }

    this.terrains = (options.terrains || []).map((line) => line.split(""));

    groundMap = this.groundMap = groundMap.map((row) => {
        if (typeof row === "string") {
            row = row.split("").map(cleverapps.castType);
        }
        return row;
    });

    this.width = groundMap[0].length;
    this.height = groundMap.length;

    const water = this.map(groundMap, (cell) => ((cell === Map2d.TILE_WATER || cell === Map2d.TILE_WATER_UNIT) ? cell : undefined));

    const borders = Map2d.BORDERS ? this.map(groundMap, () => undefined) : [];

    const ground = this.map(groundMap, (cell) => ((cell === Map2d.TILE_WATER || cell === Map2d.TILE_WATER_UNIT) ? undefined : cell));

    const chess = this.map(groundMap, (cell) => {
        if (cell === Map2d.TILE_WATER || cell === Map2d.TILE_WATER_UNIT) {
            return undefined;
        }

        if ([Map2d.TILE_IMPASSABLE_LEVEL_1, Map2d.TILE_IMPASSABLE_LEVEL_2].includes(cell)) {
            if (cleverapps.config.debugMode) {
                return Map2d.TILE_STARRED_GROUND_CHESS;
            }

            return undefined;
        }

        return Map2d.TILE_GROUND_CHESS;
    });

    const units = this.map(groundMap, () => undefined);

    const fog = this.map(groundMap, () => undefined);

    this.layers = [water, borders, ground, chess, units, fog];

    this.onAdd = function () {};
    this.onAddUnit = function () {};
    this.onAnimationsAdd = function () {};
    this.onMove = function () {};
    this.onDiscoverMapView = function () {};
    this.stopDragging = function () {};
    this.onHighlightUnit = function () {};
    this.onUnhighlightUnit = function () {};

    this.onShowTile = function () {};
    this.onRemoveTiles = function () {};
    this.showLayerTile = function () {};
    this.updateChildrenOrder = function () {};

    this.onUnitAvailableListener = function () {};
    this.onUnitFreshListener = function () {};

    this.pointer = {
        x: 0,
        y: 0
    };

    this.constructTerrains();

    if (Map2d.BORDERS) {
        ViewReader.calcBorderType(this);
    }

    this.edges = new Map2dEdges(this);

    this.screenRect = cc.rect(0, 0, 1, 1);
    this.showRect = cc.rect(0, 0, 1, 1);
    this.visibleCells = {};
    this.visibleScreenCells = [];

    this.initVisibleBoxRect();

    if (cleverapps.config.features.includes("map2d_customer")) {
        this.stock = new Stock();
        this.customers = new Customers(this.slot, this.stock);
    }

    this.fogs = cleverapps.config.editorMode ? new EditorFogs() : new Fogs(this);
    Map2dFences.createFences();

    if (cleverapps.config.features.includes("map2d_advice")) {
        this.advice = new Map2dAdvice();
    }

    this.blockedGrounds = new FogBlockedGround(this.fogs, this.slot);

    if (cleverapps.config.type === "merge" || cleverapps.meta.getSelectedLocation().locationConfig.usesWorkers) {
        this.workers = new Workers(this.slot);
    }

    if (cleverapps.config.debugMode && !cleverapps.config.editorMode
        && cleverapps.meta.getSelectedLocation().locationConfig.locationType === "merge") {
        this.orangery = new Orangery(MergeOrangery);
    }

    if (cleverapps.config.name === "wordsoup" && cleverapps.config.debugMode) {
        this.orangery = new Orangery(HomefixOrangery);
    }

    this.scroller = new Map2dScroller(this);

    if (Map2d.SMILE && !cleverapps.config.adminMode) {
        this.smile = new Smile(this.getSmiles.bind(this));
        this.smile.start();
    }

    if (Map2d.resetChessLayerVisible) {
        Map2d.resetChessLayerVisible();
    }
};

Map2d.prototype = Object.create(cleverapps.EventEmitter.prototype);
Map2d.prototype.constructor = Map2d;

Map2d.TILE_WATER = 0;
Map2d.TILE_GREEN_LEVEL_1 = 1;
Map2d.TILE_GREEN_LEVEL_2 = 2;
Map2d.TILE_IMPASSABLE_LEVEL_1 = 3;
Map2d.TILE_IMPASSABLE_LEVEL_2 = 4;
Map2d.TILE_WATER_UNIT = 9;
Map2d.TILE_GROUND_CHESS = 12;
Map2d.TILE_STARRED_GROUND_CHESS = 13;

Map2d.IMPASSABLE_LEVELS = [Map2d.TILE_IMPASSABLE_LEVEL_1, Map2d.TILE_IMPASSABLE_LEVEL_2];

Map2d.animationsTimeScale = function () {
    const location = cleverapps.meta && cleverapps.meta.getSelectedLocation();
    return location && location.locationConfig && location.locationConfig.fastAnimations ? Map2d.FAST_ANIMATIONS_TIME_SCALE : 1;
};

Map2d.FAST_ANIMATIONS_TIME_SCALE = 0.75;

Map2d.LAYER_WATER = 0;
Map2d.LAYER_BORDERS = 1;
Map2d.LAYER_GROUND = 2;
Map2d.ABOVE_GROUND = 3;
Map2d.LAYER_UNITS = 4;
Map2d.LAYER_FOG = 5;

const Iso = {
    SAME: {
        x: 0,
        y: 0
    },

    UP_LEFT: {
        y: -1,
        x: 0
    },

    UP_RIGHT: {
        y: 0,
        x: 1
    },

    UP_ABOVE: {
        y: -1,
        x: 1
    },

    DOWN_LEFT: {
        y: 0,
        x: -1
    },

    DOWN_RIGHT: {
        y: 1,
        x: 0
    },

    DOWN_BELOW: {
        y: 1,
        x: -1
    },

    HORIZONTAL_LEFT: {
        y: -1,
        x: -1
    },

    HORIZONTAL_RIGHT: {
        y: 1,
        x: 1
    }
};

const ISO_NEIGHBORS = [Iso.DOWN_LEFT, Iso.DOWN_RIGHT, Iso.UP_LEFT, Iso.UP_RIGHT];

Map2d.prototype.loadUnits = function () {
    const location = cleverapps.meta.getSelectedLocation();
    let storedUnits = [];

    if (cleverapps.config.name === "wordsoup") {
        for (let y = 0; y < this.height; y++) {
            for (let x = 0; x < this.width; x++) {
                const data = WordsoupMapSaver.loadUnit(this, x, y, this.fogs.fakeUnits);
                if (data) {
                    storedUnits.push({ x, y, data });
                }
            }
        }
    } else if (cleverapps.unitsSyncers) {
        storedUnits = cleverapps.unitsSyncers.getInstance(this.slot.slotId).listAllUnits();
    }

    storedUnits = storedUnits.filter((info) => {
        if (info.x < 0 || info.y < 0 || info.x >= this.width || info.y >= this.height) {
            cleverapps.throwAsync(`Map2d.loadUnits out of bounds: x=${info.x} y=${info.y} map=${this.width}x${this.height} unit=${info.data.code}:${info.data.stage}`);
            return false;
        }
        if (info.data.fog) {
            this.blockedGrounds.add(info.x, info.y, { fromLoad: true });
            return false;
        }
        if (Families.processUnknown) {
            info.data = Families.processUnknown(info.data, location.families);
        }
        return true;
    });

    const comparator = Map2d.LOAD_UNITS_COMPARATOR();

    storedUnits.sort((unit1, unit2) => comparator(unit1.data, unit2.data));

    storedUnits.forEach((info) => {
        const fakeUnits = this.fogs.getFakeUnits(info.x, info.y).filter((u) => !u.head);
        if (fakeUnits.length > 1) {
            const units = fakeUnits.map((unitData, index) => {
                const unit = this.createUnit(info.x, info.y, unitData);
                if (unit.findComponent(Multiple)) {
                    unit.findComponent(Multiple).init(index, fakeUnits.length, info.data && info.data.uv);
                }
                return unit;
            });
            this.add(Map2d.LAYER_UNITS, info.x, info.y, units);
        } else {
            this.createUnit(info.x, info.y, info.data);
        }
    });
};

Map2d.prototype.loadFogs = function () {
    const storedFogs = this.slot.load("fogs") || [];

    this.fogs.load(storedFogs);
    this.fogs.calcFogStates();
    this.fogs.hideBalloons();

    if (!cleverapps.config.adminMode) {
        this.blockedGrounds.load();
        this.blockedGrounds.updateBlockedGrounds(undefined, true);
        this.blockedGrounds.updateOpenedGrounds();
    }

    if (this.fogs.wantsCalcFogStates) {
        this.fogs.calcFogStates();
    }
};

Map2d.prototype.loadWorkers = function () {
    this.workers.load();
};

Map2d.prototype.saveFogs = function () {
    if (cleverapps.config.adminMode || cleverapps.config.editorMode) {
        return;
    }

    if (cleverapps.config.debugMode && cleverapps.gameModes.stopOnFogSave) {
        // eslint-disable-next-line no-debugger
        debugger;
    }

    this.slot.save("fogs", this.fogs.getInfo());
};

Map2d.prototype.onUnitFresh = function (unit) {
    this.onUnitFreshListener(unit);
};

Map2d.prototype.onUnitRemoved = function (unit) {
    this.stock && this.stock.onUnitRemoved(unit);

    if (unit.getData().feedableTarget) {
        Feedable.processFeedable();
    }

    this.trigger("onUnitRemoved", unit);
};

Map2d.prototype.onUnitAvailable = function (unit) {
    this.stock && this.stock.onUnitAvailable(unit);

    const worker = unit.findComponent(InstantWorker);
    if (worker) {
        this.workers.addInstant(worker);
    }

    const cinematic = Map2dDecorators.CreateCinematic(unit);
    if (cinematic) {
        this.planCinematics(cinematic);
    }

    this.onUnitAvailableListener(unit);

    this.trigger("onUnitAvailable", unit);
};

Map2d.prototype.focusOnUnit = function (unit, options) {
    this.scroller.focusOnUnit(unit, options);
};

Map2d.prototype.focusOnTarget = function (target, options) {
    this.scroller.focusOnTarget(target, options);
};

Map2d.prototype.exploreArea = function (fakeUnit, callback) {
    this.scroller.exploreArea(fakeUnit, callback);
};

Map2d.prototype.getFocusCell = function () {
    return this.scroller.scrollCell;
};

Map2d.prototype.initFocusCell = function () {
    let scrollCell = undefined;
    this.scroller.zoom = this.scroller.getBasicZoom();
    scrollCell = this.fogs.blocks.fog0 && this.fogs.blocks.fog0.head;
    if (!scrollCell) {
        scrollCell = this.getMapCenterCell();
    }

    if (cleverapps.config.demoMode) {
        const units = this.listAvailableUnits();
        const geometricCenter = units.reduce((total, unit) => cc.pAdd(total, cc.pMult(unit, 1 / units.length)), cc.p(0, 0));
        scrollCell = cc.p(Math.floor(geometricCenter.x), Math.floor(geometricCenter.y));
    }
    this.scroller.setScrollCell(scrollCell);
};

Map2d.prototype.onPositionChanged = function () {
    this.trigger("onPositionChanged");
    this.scroller.onUpdateScroll();
};

Map2d.prototype.prepareVisibleBox = function (visibleBox) {
    if (Array.isArray(visibleBox)) {
        visibleBox = visibleBox.slice().reverse().find((visibleBox) => cleverapps.user.checkAvailable(visibleBox.available)
                || cleverapps.config.editorMode || cleverapps.config.adminMode);
    }

    if (visibleBox.cutLeft === undefined && visibleBox.cutRight === undefined) {
        visibleBox.cutRight = (1 - visibleBox.width) / 2;
        visibleBox.cutLeft = visibleBox.cutRight;
    }

    if (visibleBox.cutTop === undefined && visibleBox.cutBottom === undefined) {
        visibleBox.cutTop = (1 - visibleBox.height) / 2;
        visibleBox.cutBottom = visibleBox.cutTop;
    }

    return visibleBox;
};

Map2d.prototype.initWorkers = function () {
    this.workers.regular.forEach((worker) => {
        worker.run();
    });

    this.workers.runSpecialWorkers();
    this.workers.onChangeTotalAmount();

    const worker = this.workers.findLeastBusy(Buildable);
    if (worker && worker.getTimeLeft() <= 0) {
        Map2d.currentMap.focusOnUnit(worker.unit, {
            allowScrollWithFocus: true
        });
    }
};

Map2d.prototype.getMapView = function () {
    return this.onDiscoverMapView();
};

Map2d.prototype.stop = function () {
    runCleaners(this);

    Feedable.Clear();
    this.counter.turnOff();

    this.stopped = true;

    Object.values(this.actionPlayers).forEach((player) => {
        player.stop();
    });

    this.listAvailableUnits().forEach((unit) => {
        unit.destructor();
    });
    this.decorators.destructor();

    if (this.pathIndicator) {
        this.pathIndicator.destructor();
    }

    this.advice && this.advice.destructor();

    if (this.workers) {
        this.workers.destructor();
    }

    if (this.smile) {
        this.smile.stop();
    }

    this.onRemoveTiles = function () {};
    this.onShowTile = function () {};
    this.showLayerTile = function () {};
    this.updateChildrenOrder = function () {};
    this.onUnitAvailableListener = function () {};
    this.onUnitFreshListener = function () {};

    this.trigger("stop");
    Map2d.currentMap = undefined;
    Map2dScroller.currentScroller = undefined;
};

Map2d.prototype.setPointer = function (x, y) {
    this.pointer.x = x;
    this.pointer.y = y;
};

Map2d.prototype.initVisibleBoxRect = function () {
    const size = this.width + this.height;
    const top = this.width - 1;
    const bottom = -this.height + 1;

    const minX = size / 2 - size * (0.5 - this.visibleBox.cutLeft) - this.waterBorder;
    const maxX = size / 2 + size * (0.5 - this.visibleBox.cutRight) + this.waterBorder;
    const minY = bottom + size * this.visibleBox.cutBottom - this.waterBorder;
    const maxY = top - size * this.visibleBox.cutTop + this.waterBorder;

    this.visibleBoxRect = cc.rect(
        Math.floor((minX + minY) / 2),
        Math.floor((minX - minY) / 2),
        Math.ceil((maxX - minX) / 2),
        Math.ceil((maxY - minY) / 2)
    );
};

Map2d.prototype.map = function (array2d, iterator) {
    return array2d.map(function (row, y) {
        return row.map((cell, x) => iterator(cell, x, y), this);
    }, this);
};

Map2d.prototype.getGround = function (dir) {
    return this.layers[Map2d.LAYER_GROUND][this.pointer.y + dir.y] && this.layers[Map2d.LAYER_GROUND][this.pointer.y + dir.y][this.pointer.x + dir.x];
};

Map2d.prototype.getTileAboveGround = function (dir) {
    return this.layers[Map2d.ABOVE_GROUND][this.pointer.y + dir.y] && this.layers[Map2d.ABOVE_GROUND][this.pointer.y + dir.y][this.pointer.x + dir.x];
};

Map2d.prototype.isValid = function (x, y) {
    return x >= 0 && x < this.width && y >= 0 && y < this.height;
};

Map2d.prototype.getTerrainCode = function (x, y) {
    if (typeof x === "object" && x.direction) {
        y = this.pointer.y + x.y;
        x = this.pointer.x + x.x;
    }

    return this.terrains[y] && this.terrains[y][x] || Map2d.TERRAIN_GREEN;
};

Map2d.prototype.setTerrain = function (x, y, value) {
    this.terrains[y][x] = value;
};

Map2d.prototype.getTerrainType = function (x, y) {
    const tilesTexture = Map2d.getTilesTexture(this.tilesSkin);

    const defaultTerrain = bundles[tilesTexture].meta.defaultTerrain;

    return {
        code: Map2d.TERRAINS[this.getTerrainCode(x, y)],
        name: `${tilesTexture}_${Map2d.TERRAINS[this.getTerrainCode(x, y)]}`,
        defaultTiles: `${tilesTexture}_${defaultTerrain}`,
        defaultTerrain
    };
};

Map2d.prototype.getTerrainConfig = function (x, y) {
    const type = this.getTerrainType(x, y);
    return Map2d.TERRAIN_CONFIG[type.name] || Map2d.TERRAIN_CONFIG.default;
};

Map2d.prototype.getTerrainFrames = function (x, y) {
    const type = this.getTerrainType(x, y);
    return (Map2d.TERRAIN_BUNDLES[type.name] || bundles[type.defaultTiles]).frames;
};

Map2d.prototype.getTerrainFrameData = function (name, x, y) {
    const frames = this.getTerrainFrames(x, y);
    const config = this.getTerrainConfig(x, y);
    return { res: frames[name], options: config.frames[name] || {} };
};

Map2d.prototype.getValue = function (layerId, x, y) {
    if (typeof x === "object") {
        if (x.direction) {
            y = this.pointer.y + x.y;
            x = this.pointer.x + x.x;
        } else {
            y = x.y;
            x = x.x;
        }
    }

    if (layerId === Map2d.LAYER_WATER && (x < 0 || x >= this.getWidth() || y < 0 || y >= this.getHeight())
        && cc.isoRectContainsPoint(this.visibleBoxRect, x, y) && !cleverapps.config.editorMode) {
        return Map2d.TILE_WATER;
    }

    return this.layers[layerId][y] && this.layers[layerId][y][x];
};

Map2d.prototype.setValue = function (layer, dir, value) {
    const x = this.pointer.x + dir.x;
    const y = this.pointer.y + dir.y;
    this.trigger("removeValue", layer, x, y);
    this.layers[layer][y][x] = value;
    this.trigger("setValue", layer, x, y);
};

Map2d.prototype.add = function (layer, x, y, unit) {
    if (x < 0 || y < 0 || y >= this.height || x >= this.width) {
        const info = unit instanceof Unit ? `${unit.code}:${unit.stage}` : "array";
        const head = unit instanceof Unit && unit.head ? ` head=${unit.head.code}:${unit.head.stage}@${unit.head.x},${unit.head.y}` : "";
        cleverapps.throwAsync(`Map2d.add out of bounds: layer=${layer} x=${x} y=${y} map=${this.width}x${this.height} unit=${info}${head}`);
        return;
    }
    this.layers[layer][y][x] = unit;
};

Map2d.prototype.getFog = function (x, y) {
    return this.layers[Map2d.LAYER_FOG][y] && this.layers[Map2d.LAYER_FOG][y][x];
};

Map2d.prototype.isOccupiedByFog = function (x, y) {
    return this.getFog(x, y) !== undefined && !cleverapps.config.editorMode;
};

Map2d.prototype.remove = function (layer, x, y) {
    if (this.dragging && layer === Map2d.LAYER_UNITS && this.dragging.x === x && this.dragging.y === y) {
        cleverapps.throwAsync("Remove draggging unit");
    }
    if (layer === Map2d.LAYER_UNITS) {
        const unit = this.getUnit(x, y);
        if (unit) {
            unit.removeStack = `x - ${x}, y - ${y}, stack - ${new Error().stack}`;
            // console.log(unit.removeStack);
        }
    }
    this.layers[layer][y][x] = undefined;
};

Map2d.prototype.isWaterUnit = function (x, y) {
    return this.layers[Map2d.LAYER_WATER][y] && this.layers[Map2d.LAYER_WATER][y][x] === Map2d.TILE_WATER_UNIT;
};

Map2d.prototype.isGround = function (x, y) {
    if (this.getValue(Map2d.LAYER_BORDERS, x, y)) {
        return false;
    }

    const value = this.getValue(Map2d.LAYER_GROUND, x, y);
    return [Map2d.TILE_GREEN_LEVEL_1, Map2d.TILE_GREEN_LEVEL_2].includes(value);
};

Map2d.prototype.isImpassableGround = function (x, y) {
    if (this.getValue(Map2d.LAYER_BORDERS, x, y)) {
        return false;
    }

    const value = this.getValue(Map2d.LAYER_GROUND, x, y);
    return Map2d.IMPASSABLE_LEVELS.includes(value);
};

Map2d.prototype.calcGroundLevel = function (x, y) {
    const ground = this.getValue(Map2d.LAYER_GROUND, x, y);
    if (ground === Map2d.TILE_GREEN_LEVEL_1 || ground === Map2d.TILE_IMPASSABLE_LEVEL_1) {
        return Map2d.TILE_GREEN_LEVEL_1;
    }
    if (ground === Map2d.TILE_GREEN_LEVEL_2 || ground === Map2d.TILE_IMPASSABLE_LEVEL_2) {
        return Map2d.TILE_GREEN_LEVEL_2;
    }

    return Map2d.TILE_WATER;
};

Map2d.prototype.getUnit = function (x, y) {
    const data = this.layers[Map2d.LAYER_UNITS][y] && this.layers[Map2d.LAYER_UNITS][y][x];
    if (data && Array.isArray(data)) {
        return data[0];
    }
    return data;
};

Map2d.prototype.getUnits = function (x, y) {
    const data = this.layers[Map2d.LAYER_UNITS][y] && this.layers[Map2d.LAYER_UNITS][y][x];
    if (!data) {
        return [];
    }
    return Array.isArray(data) ? data : [data];
};

Map2d.prototype.iterateUnits = function (x, y, iterator) {
    const layer = this.layers[Map2d.LAYER_UNITS];
    const data = layer[y] && layer[y][x];
    if (data) {
        if (Array.isArray(data)) {
            data.forEach(iterator);
        } else {
            iterator(data);
        }
    }
};

Map2d.prototype.getUnitWithHead = function (x, y) {
    const unit = this.getUnit(x, y);
    if (unit && unit.head) {
        return unit.head;
    }
    return unit;
};

Map2d.prototype.bfs = function (x, y, filter) {
    if (!filter(x, y)) {
        return [];
    }

    const dirs = ISO_NEIGHBORS;
    const area = [{ x, y }];

    const used = {};
    used[this.getPositionKey(x, y)] = true;

    let pointer = 0;
    while (pointer < area.length) {
        const p = area[pointer++];
        for (let i = 0; i < dirs.length; i++) {
            const tx = p.x + dirs[i].x;
            const ty = p.y + dirs[i].y;

            const key = this.getPositionKey(tx, ty);
            if (!used[key]) {
                used[key] = true;

                if (filter(tx, ty)) {
                    area.push({ x: tx, y: ty });
                }
            }
        }
    }

    return area;
};

Map2d.prototype.iterateBfs = function (x, y, iterator) {
    const dirs = ISO_NEIGHBORS;
    const queue = [{ x, y, step: 0 }];

    const used = {};
    used[this.getPositionKey(x, y)] = true;

    let pointer = 0;
    while (pointer < queue.length) {
        const p = queue[pointer++];

        if (iterator(p)) {
            return;
        }

        for (let i = 0; i < dirs.length; i++) {
            const tx = p.x + dirs[i].x;
            const ty = p.y + dirs[i].y;

            const key = this.getPositionKey(tx, ty);
            if (!used[key]) {
                used[key] = true;

                if (tx >= 0 && tx < this.width && ty >= 0 && ty < this.height) {
                    queue.push({ x: tx, y: ty, step: p.step + 1 });
                }
            }
        }
    }
};

Map2d.prototype.getPositionKey = function (x, y) {
    return x + y * this.width;
};

Map2d.prototype.compareMergeable = function (target, x, y) {
    const unit = this.getUnit(x, y);
    return unit && !unit.isBlocked() && !this.getFog(x, y) && target.isMergeable(unit);
};

Map2d.prototype.compareEqual = function (target, x, y) {
    const unit = this.getUnit(x, y);
    return unit && !unit.isDragged() && !this.getFog(x, y) && Unit.Equals(target, unit);
};

Map2d.prototype.setScreenRect = function (screenRect) {
    this.screenRect = screenRect;
};

Map2d.prototype.setShowRect = function (showRect, force) {
    this.lastScrollTime = cleverapps.timeouts.time;

    const showCells = showRect.cells || {};

    if (cc.rectEqualToRect(showRect, this.showRect) && !force) {
        return;
    }

    const needShow = function (x, y) {
        return cc.isoRectContainsPoint(showRect, x, y) || showCells[y] && showCells[y][x];
    };

    for (const y in this.visibleCells) {
        for (const x in this.visibleCells[y]) {
            if (!needShow(+x, +y) && this.canHideTile(+x, +y)) {
                this.hideTile(+x, +y);
            }
        }
    }

    const multicells = new Set();

    cc.iterateIsoRect(showRect, (x, y) => {
        this.iterateUnits(x, y, (unit) => {
            if (unit.head) {
                multicells.add(unit.head);
            } else if (unit.getShape().length > 1) {
                multicells.add(unit);
            }
        });

        this.showTile(x, y);
    });

    multicells.forEach((unit) => {
        unit.getShape().forEach((part) => {
            this.showTile(unit.x + part.x, unit.y + part.y);
        });
    });

    for (const y in showCells) {
        for (const x in showCells[y]) {
            this.showTile(+x, +y);
        }
    }

    this.showRect = showRect;
};

Map2d.prototype.canHideTile = function (x, y) {
    let cantHideTile = false;

    this.iterateUnits(x, y, (unit) => {
        cantHideTile = cantHideTile || !unit.canHideTile();
    });

    return !cantHideTile;
};

Map2d.prototype.showTile = function (x, y) {
    // always hides map corners, except special case in (0, 0) for permanent views like WorkerView
    if (!cc.isoRectContainsPoint(this.visibleBoxRect, x, y) && x !== 0 && y !== 0) {
        return;
    }

    if (this.isVisibleCell(x, y)) {
        return;
    }

    this.addVisibleCell(x, y);
    this.onShowTile(x, y);

    this.iterateUnits(x, y, (unit) => {
        unit.onShowTile();
    });
};

Map2d.prototype.hideTile = function (x, y) {
    if (!this.isVisibleCell(x, y)) {
        return;
    }

    this.removeVisibleCell(x, y);

    this.iterateUnits(x, y, (unit) => {
        unit.onHideTile();
    });
};

Map2d.prototype.removeTiles = function (cells) {
    cells.forEach((cell) => this.hideTile(cell.x, cell.y));

    this.onRemoveTiles(cells);
};

Map2d.prototype.setChildrenOrderDirty = function () {
    this.childrenOrderDirty = true;

    if (engine === "cocos2d") {
        cc.renderer.setChildrenOrderDirty();
    }
};

Map2d.prototype.update = function () {
    if (this.childrenOrderDirty) {
        this.updateChildrenOrder();
        this.childrenOrderDirty = false;
    }
};

Map2d.prototype.removeVisibleCell = function (x, y) {
    if (!this.isVisibleCell(x, y)) {
        return;
    }

    delete this.visibleCells[y][x];
    this.removeVisibleScreenCell(this.isoToScreen(x, y));
};

Map2d.prototype.addVisibleCell = function (x, y) {
    if (this.isVisibleCell(x, y)) {
        return;
    }

    if (!this.visibleCells[y]) {
        this.visibleCells[y] = {};
    }

    this.visibleCells[y][x] = true;
    this.addVisibleScreenCell(this.isoToScreen(x, y));
};

Map2d.prototype.addVisibleScreenCell = function (x, y) {
    if (y === undefined) {
        y = x.y;
        x = x.x;
    }

    let line = this.visibleScreenCells[y];
    if (!line) {
        line = this.visibleScreenCells[y] = [];
    }

    line.push(x);

    for (let i = line.length - 1; i > 0; i--) {
        if (line[i - 1] <= x) {
            break;
        }

        line[i] = line[i - 1];
        line[i - 1] = x;
    }
};

Map2d.prototype.removeVisibleScreenCell = function (x, y) {
    if (y === undefined) {
        y = x.y;
        x = x.x;
    }
    cc.arrayRemoveObject(this.visibleScreenCells[y], x);
};

Map2d.prototype.iterateVisibleIsoCells = function (iterator) {
    let x, iso;
    for (let y = this.visibleScreenCells.length - 1; y >= 0; y--) {
        const line = this.visibleScreenCells[y];
        if (line) {
            for (let i = line.length - 1; i >= 0; i--) {
                x = line[i];
                iso = this.screenToIso(x, y);
                iterator(iso.x, iso.y);
            }
        }
    }
};

Map2d.prototype.getShowRect = function () {
    return this.showRect;
};

Map2d.prototype.isVisibleCell = function (x, y) {
    return this.visibleCells[y] && this.visibleCells[y][x];
};

Map2d.prototype.getScreenCenterCell = function () {
    return cc.isoRectGetCenter(this.screenRect);
};

Map2d.prototype.getMapCenterCell = function () {
    return cc.p(Math.round(this.width / 2), Math.round(this.height / 2));
};

Map2d.prototype.listAvailableGrounds = function () {
    const cells = [];

    for (let y = 0; y < this.getHeight(); y++) {
        for (let x = 0; x < this.getWidth(); x++) {
            if (this.isGround(x, y) && !this.getFog(x, y)) {
                cells.push(cc.p(x, y));
            }
        }
    }

    return cells;
};

Map2d.prototype.listAvailableUnits = function (filter) {
    const units = [];

    if (filter && typeof filter !== "function") {
        filter = Unit.IsApplicable.bind(Unit, filter);
    }

    for (let y = 0; y < this.getHeight(); y++) {
        for (let x = 0; x < this.getWidth(); x++) {
            this.iterateUnits(x, y, (unit) => {
                if (!filter || filter(unit)) {
                    units.push(unit);
                }
            });
        }
    }

    return units;
};

Map2d.prototype.listAvailableUnitsInRegion = function (region, targets) {
    const units = [];

    if (!this.regions[region]) {
        return units;
    }

    this.regions[region].positions.forEach(function (cell) {
        this.iterateUnits(cell.x, cell.y, (unit) => {
            if (Unit.IsApplicable(targets, unit)) {
                units.push(unit);
            }
        });
    }, this);

    return units;
};

Map2d.prototype.isEmpty = function (x, y) {
    return this.isGround(x, y) && !this.getUnit(x, y) && !this.isOccupiedByFog(x, y);
};

Map2d.prototype.countEmptySlots = function () {
    let amount = 0;
    for (let y = 0; y < this.getHeight(); y++) {
        for (let x = 0; x < this.getWidth(); x++) {
            if (this.isEmpty(x, y)) {
                amount++;
            }
        }
    }
    return amount;
};

Map2d.prototype.findEmptySlot = function (x, y, unit, options) {
    options = options || {};

    const index = ISO_NEIGHBORS;

    const checkEqualCell = function (cell) {
        for (let i = 0; i < index.length; i++) {
            const otherUnit = this.getUnit(cell.x + index[i].x, cell.y + index[i].y);
            if (Unit.Equals(unit, otherUnit) && !this.isOccupiedByFog(cell.x + index[i].x, cell.y + index[i].y)) {
                return true;
            }
        }
    }.bind(this);

    const checkSameLineCell = function (cell) {
        for (let i = 0; i < index.length; i++) {
            const otherUnit = this.getUnit(cell.x + index[i].x, cell.y + index[i].y);
            if (Unit.SameLine(unit, otherUnit) && !this.isOccupiedByFog(cell.x + index[i].x, cell.y + index[i].y)) {
                return true;
            }
        }
    }.bind(this);

    PseudoRandom.GET().shuffle(index);

    const shape = Unit.GetShape(unit);
    const checkScreen = options.skipCheckScreen !== undefined ? !options.skipCheckScreen : true;
    const skipCheckEqual = options.skipCheckEqual;
    let firstCell;
    let screenCell;
    let equalCell;
    let sameLineCell;
    let sameLineAndScreenCell;
    const radius = options.radius !== undefined ? options.radius : Map2d.RADIUS_BIG;
    let hasScreenCell = true;

    for (let d = 0; d < 100; d++) {
        if (firstCell) {
            if (d > radius || (!checkScreen && !hasScreenCell)) {
                break;
            }
        }
        hasScreenCell = false;

        for (let dd = 0; dd <= d; dd++) {
            for (let j = 0; j < 2; j++) {
                let rd = dd;
                if (j > 0) {
                    if (dd === 0) {
                        continue;
                    }
                    rd = -dd;
                }
                for (let i = 0; i < index.length; i++) {
                    const nx = x + ((index[i].x === 0) ? rd : (index[i].x * d));
                    const ny = y + ((index[i].y === 0) ? rd : (index[i].y * d));

                    const cells = shape.map((part) => ({
                        x: nx + part.x,
                        y: ny + part.y
                    }));

                    if (options.area && !cells.every((cell) => options.area.some((areaCell) => areaCell.x === cell.x && areaCell.y === cell.y))) {
                        continue;
                    }

                    let isScreenCell = false;

                    isScreenCell = cells.every(this.isScreenCell.bind(this));
                    if (isScreenCell) {
                        hasScreenCell = true;
                    }

                    const isEqualCell = cells.every(checkEqualCell);
                    const isSameLineCell = cells.every(checkSameLineCell);

                    if (cells.every(function (cell) {
                        return this.isEmpty(cell.x, cell.y);
                    }, this)) {
                        const cell = cc.p(nx, ny);
                        firstCell = firstCell || cell;
                        if (isScreenCell) {
                            screenCell = screenCell || cell;
                            if (isEqualCell || skipCheckEqual) {
                                return cell;
                            }
                            if (isSameLineCell) {
                                sameLineAndScreenCell = sameLineAndScreenCell || cell;
                            }
                        }
                        if (isSameLineCell) {
                            sameLineCell = sameLineCell || cell;
                        }
                        if (isEqualCell) {
                            equalCell = equalCell || cell;
                        }
                    }
                }
            }
        }
    }

    return sameLineAndScreenCell || screenCell || equalCell || sameLineCell || firstCell;
};

Map2d.prototype.hasMergeable = function () {
    const mergeable = {};
    const units = this.listAvailableUnits();
    for (let i = 0; i < units.length; i++) {
        const unit = units[i];
        if (unit.isMergeable(unit)) {
            const code = unit.code;
            const stage = unit.stage;
            mergeable[code] = mergeable[code] || {};
            mergeable[code][stage] = mergeable[unit.code][stage] || [];
            mergeable[code][stage].push(unit);
            if (mergeable[code][stage].length > 2) {
                return unit;
            }
        }
    }
};

Map2d.prototype.isScreenCellPosition = function (x, y) {
    return cc.isoRectContainsPoint(this.screenRect, x, y);
};
Map2d.prototype.isScreenCell = function (cell) {
    return this.isScreenCellPosition(cell.x, cell.y);
};

Map2d.prototype.getCenterDistance = function (x, y) {
    const center = this.getScreenCenterCell();
    return center ? cc.pDistance(center, cc.p(x, y)) : 1e3;
};

Map2d.prototype.constructTerrains = function () {
    for (let y = 0; y < this.getHeight(); y++) {
        if (this.terrains.length <= y) {
            this.terrains.push([]);
        }
        for (let x = 0; x < this.getWidth(); x++) {
            if (this.terrains[y].length <= x) {
                this.terrains[y].push(Map2d.TERRAIN_EMPTY);
            }
            if (this.terrains[y][x] === Map2d.TERRAIN_EMPTY && this.calcGroundLevel(x, y)) {
                this.terrains[y][x] = Map2d.TERRAIN_GREEN;
            }
        }
    }
};

Map2d.prototype.getWidth = function () {
    return this.width;
};

Map2d.prototype.getHeight = function () {
    return this.height;
};

Map2d.prototype.setDragging = function (unit) {
    this.dragging = unit;
    this.trigger("changeDragging", unit);
};

Map2d.prototype.highlightUnit = function (unit, f, options) {
    f = f || (() => {});

    if (!unit || !unit.onGetView) {
        f();
        return;
    }

    this.onHighlightUnit(unit, f, options);
};

Map2d.prototype.unhighlightUnit = function (f = () => {}) {
    this.onUnhighlightUnit(f);
};

Map2d.prototype.reportUnrestoredIntact = function (x, y) {
    if (!this.unrestoredIntacts) {
        this.unrestoredIntacts = [];

        setTimeout(() => {
            cleverapps.throwAsync(`can't restore intact units (${this.unrestoredIntacts.length}): ${this.unrestoredIntacts.join(", ")}`);
            delete this.unrestoredIntacts;
        }, 0);
    }

    this.unrestoredIntacts.push(`${x} ${y}`);
};

Map2d.prototype.createUnit = function (x, y, data) {
    const wasIntact = data.code === "intact";

    if (wasIntact) {
        const fakeUnit = this.fogs.getFakeUnit(x, y);
        if (fakeUnit && !fakeUnit.head) {
            data.code = fakeUnit.code;
            data.stage = fakeUnit.stage;
        } else if (cleverapps.config.debugMode) {
            this.reportUnrestoredIntact(x, y);
            return;
        } else {
            return;
        }
    }

    // compatability with old format in case if unknown units was stored in LS like unknown
    if (data.code === "unknown") {
        const originalData = data._data;
        if (originalData && this.families[originalData.code] && Families[originalData.code] && Families[originalData.code].units[originalData.stage]) {
            data = originalData;
        }
    }

    if (!this.families[data.code] || !Families[data.code] || !Families[data.code].units[data.stage]) {
        data = {
            code: "unknown",
            stage: 0,
            _data: data
        };
    }

    this.currentLoadingUnitPosition = { x, y };

    const unit = new Unit(data, x, y);
    if (wasIntact) {
        unit.intact = true;
    }
    unit.setPosition(x, y);
    this.add(Map2d.LAYER_UNITS, x, y, unit);
    this.onAddUnit(x, y, unit);
    return unit;
};

Map2d.prototype.findLargestGroup = function (units) {
    const used = {};
    let largestArea = [];

    units.forEach(function (unit) {
        if (used[Unit.GetPositionKey(unit)]) {
            return;
        }

        const area = this.bfs(unit.x, unit.y, this.compareEqual.bind(this, unit));
        area.forEach((cell) => {
            used[Unit.GetPositionKey(cell)] = true;
        });

        if (area.length > largestArea.length) {
            largestArea = area;
        }
    }, this);

    return largestArea.map(function (cell) {
        return this.getUnit(cell.x, cell.y);
    }, this);
};

Map2d.prototype.isUnitClick = function (unit) {
    return this.getUnits(unit.x, unit.y).find((u) => u === unit) !== undefined;
};

Map2d.prototype.isFogClick = function (fog) {
    return fog === this.getFog(fog.x, fog.y);
};

Map2d.prototype.onDebugCellClick = function (cell) {
    if (cleverapps.config.debugMode) {
        this.getUnits(cell.x, cell.y).forEach((unit) => {
            console.log(unit.getConsoleInfo());
        });

        const fog = this.getFog(cell.x, cell.y);
        if (fog && fog.fogBlock) {
            console.log(fog.fogBlock.getConsoleInfo());
        }
    }
};

Map2d.prototype.createUnitFromOrangery = function (template, cell) {
    if (this.isOccupiedByFog(cell.x, cell.y)) {
        return;
    }

    let unit = this.getUnit(cell.x, cell.y);
    if (template.eraser && unit) {
        if (unit.isMultiCellBody()) {
            unit = unit.head;
        }
        unit.debugRemove();
        return;
    }

    if (!template.eraser && !unit) {
        if (Unit.CreateDebug(template, cell)) {
            cleverapps.effects.fire("merge.spawn.landing");
        }
    }
};

Map2d.prototype.isCloseToMapLeft = function (cell) {
    const centerCell = this.getScreenCenterCell();
    return Map2dInnerView.IsoToScreen(cell.x, cell.y).x < Map2dInnerView.IsoToScreen(centerCell.x, centerCell.y).x;
};

Map2d.prototype.animateFogTileOpen = function (tile, silent, callback) {
    const player = new ActionPlayer([
        function (f) {
            this.counter.inc();

            tile.onOpen(f, silent);
        }.bind(this),

        function (f) {
            const units = this.getUnits(tile.x, tile.y);
            if (units.length > 0) {
                f = cleverapps.wait(units.length, f);
                this.onAddUnit(tile.x, tile.y);
                units.forEach((unit) => {
                    this.onUnitAvailable(unit);
                    unit.showUp(f);
                });
            } else {
                f();
            }
        }.bind(this),

        function (f) {
            callback && callback();
            f();
            this.counter.dec();
        }.bind(this)
    ]);

    const uid = this.lastActionPlayer++;
    this.actionPlayers[uid] = player;

    player.onComplete(() => {
        delete this.actionPlayers[uid];
    });

    player.play();
};

Map2d.prototype.planCinematics = function (cinematic) {
    this.cinematics.push(cinematic);
};

Map2d.prototype.playCinematics = function () {
    if (!this.cinematics.length || this.dragging || cleverapps.focusManager.isFocused()) {
        return;
    }

    cleverapps.focusManager.display({
        focus: "StartUnitGreeting",
        actions: cleverapps.toArray(this.cinematics.shift())
    });
};

Map2d.prototype.addHero = function (unit) {
    const index = this.heroes.indexOf(unit);
    if (index === -1) {
        this.heroes.push(unit);
    }
};

Map2d.prototype.removeHero = function (unit) {
    const index = this.heroes.indexOf(unit);
    if (index !== -1) {
        this.heroes.splice(index, 1);
    }
};

Map2d.prototype.listAvailableHeroes = function () {
    return this.heroes.slice();
};

Map2d.prototype.getSmiles = function () {
    return this.listAvailableUnits()
        .filter((unit) => unit.canSmile());
};

Map2d.prototype.getBackgroundBundle = function () {
    return bundles[Map2d.getBackgroundBundles(cleverapps.meta.selectedLocationId())];
};

Map2d.prototype.getBackgroundPosition = function () {
    return cc.p((this.background.x || 0) * resolutionScale, (this.background.y || 0) * resolutionScale);
};

Map2d.prototype.getBackgroundScale = function () {
    return cc.p(this.background.scaleX || 1, this.background.scaleY || 1);
};

Object.keys(Iso).forEach((key) => {
    Iso[key].direction = true;
    Iso[key].key = key;
});

Map2d.getTilesTexture = function (skin) {
    return `tiles_${skin}`;
};

Map2d.getUnitsTexture = function (skin) {
    return `units_${skin}`;
};

Map2d.getCustomUnitsTexture = function () {
    return `custom_units_${cleverapps.meta.selectedLocationId()}`;
};

Map2d.getBackgroundBundles = function (locationId) {
    return `background_${locationId}`;
};

Map2d.getEditorVisibleBox = function (visibleBox) {
    visibleBox = visibleBox || {};
    const result = cleverapps.clone(Map2d.EDITOR_VISIBLE_BOX, true);
    Object.keys(result).forEach((key) => {
        result[key] = Math.min(result[key], visibleBox[key] || Map2d.EDITOR_VISIBLE_BOX[key]);
    });
    return result;
};

Map2d.RADIUS_SMALL = 3;
Map2d.RADIUS_BIG = 5;

Map2d.EDITOR_VISIBLE_BOX = {
    "cutRight": 0, "cutLeft": 0, "cutTop": 0, "cutBottom": 0 
};

Map2d.VISIBLE_BOX = {
    width: 0.5,
    height: 0.5
};

Map2d.TILES_VISIBLE_RECT_FRAME = cc.rect(-1, -2, 2, 4);

Map2d.WATER_BORDER = 10;

Map2d.TERRAIN_EMPTY = ".";
Map2d.TERRAIN_GREEN = "g";
Map2d.TERRAIN_ROAD = "a";
Map2d.TERRAIN_DEMO = "e";

Map2d.TERRAINS = {
    g: "green",
    i: "ice",
    p: "purple",
    s: "sand",
    b: "blue",
    f: "fort",
    y: "yellow",
    m: "default",
    r: "garage",
    t: "tavern",
    l: "lightgreen",
    d: "darkgreen",
    a: "road",
    e: "demo"
};

Map2d.TERRAIN_BUNDLES = {};

Map2d.AVAILABLE_TILES = [];
Map2d.AVAILABLE_UNITS = [];

Map2d.BORDERS = false;

Map2d.SMILE = false;

if (cleverapps.config.type === "merge") {
    Map2d.BORDERS = true;
}

Object.keys(bundles).forEach((name) => {
    if (name.match(/^tiles_[^_]+$/)) {
        Map2d.AVAILABLE_TILES.push(name);
    }

    if (name.match(/^units_[^_]+$/)) {
        Map2d.AVAILABLE_UNITS.push(name);
    }
});

Object.keys(Map2d.TERRAINS).forEach((code) => {
    Map2d.AVAILABLE_TILES.forEach((tilesTexture) => {
        const terrain = Map2d.TERRAINS[code];

        const bundle = bundles[`${tilesTexture}_${terrain}`];
        if (!bundle) {
            return;
        }

        Map2d.TERRAIN_BUNDLES[`${tilesTexture}_${terrain}`] = bundle;

        Object.keys(bundle.frames).forEach((frameId) => {
            const baseId = frameId.replace(`_${terrain}`, "");

            if (bundle.frames[frameId] && !bundle.frames[baseId]) {
                bundle.frames[baseId] = bundle.frames[frameId];
            }
        });
    });
});

Map2d.InsertDefaults = function (map, defaults) {
    defaults.forEach((item) => {
        if (item.code === "unknown" || !Families[item.code] || !Families[item.code].units.length) {
            console.error(`Trying to insert non-existent unit '${item.code}_${item.stage}'`);
            item.code = "unknown";
            item.stage = 0;
        }

        item = Fogs.ReadMapUnit(item);
        if (!item || map.getFog(item.x, item.y)) {
            return;
        }

        const unit = new Unit(item);

        const x = item.x;
        const y = item.y;

        const existingUnits = map.getUnits(x, y);
        unit.setPosition(x, y);
        let unitToAddToMap = unit;
        if (unit.findComponent(Multiple)) {
            const existingMultiple = existingUnits.filter((u) => u.findComponent(Multiple));
            unit.findComponent(Multiple).init(existingMultiple.length, existingMultiple.length + 1);
            existingMultiple.forEach((u) => u.findComponent(Multiple).unitsVisibility.push(1));
            unitToAddToMap = unit.findComponent(Multiple).joinWith(existingUnits);
        }
        map.add(Map2d.LAYER_UNITS, x, y, unitToAddToMap);

        unit.destructor();
    });
};

Map2d.LOAD_UNITS_COMPARATOR = function () {
    const getTypeIndex = function (unit) {
        const familyUnits = Families[unit.code] && Families[unit.code].units || [];
        let index = 0;

        if (familyUnits[unit.stage] && familyUnits[unit.stage].heroitem) {
            index = unit.stage + 1;

            if (index === familyUnits.length) {
                index += 1000;
            }
        }

        return index;
    };

    return function (unit1, unit2) {
        const typeIndex1 = getTypeIndex(unit1);
        const typeIndex2 = getTypeIndex(unit2);

        return (typeIndex2 - typeIndex1) || unit1.code.localeCompare(unit2.code) || (unit2.stage - unit1.stage);
    };
};

Map2d.mapEvent = function (type, options) {
    if (!Map2d.currentMap || Map2d.currentMap.stopped) {
        cleverapps.throwAsync(`throw event after map is stopped ${type}`);
        return;
    }

    cleverapps.eventBus.trigger("mapEvent", type, options);

    cleverapps.eventBus.trigger(`weeklygoals-${type}`, type === Map2d.MERGE ? options.affected.length : undefined);

    if (type === Map2d.CLICK_UNIT) {
        cleverapps.tutorial.trigger(Map2d.CLICK_UNIT, options.affected);
    }

    if (type === Map2d.SPAWN) {
        if (HeroItem.IsOneOfTwoLastHeroItems(options.unit)) {
            cleverapps.eventBus.trigger("ONE_OF_TWO_LAST_HERO_ITEMS_SPAWNED");
        }

        if (options.unit) {
            const unit = options.unit;
            const family = Families[unit.code];

            if (unit.stage >= family.units.length - 5 && family.type === "resource") {
                cleverapps.eventBus.trigger("ONE_OF_TWO_LAST_UNIT_STAGES_SPAWNED");
            }
            cleverapps.eventBus.trigger(`UNIT_SPAWN_${unit.code}_${unit.stage}`);
        }

        if (HeroItem.IsFirstHeroItem(options.unit)) {
            cleverapps.eventBus.trigger("FIRST_HERO_ITEM_SPAWNED");
        }
    }

    if (type === Map2d.OPENFOG) {
        cleverapps.eventBus.trigger(`FOG_${options.fog}`);
    }
};

Map2d.prototype.isoToScreen = function (x, y) {
    return {
        x: x + y,
        y: x - y + this.height
    };
};

Map2d.prototype.screenToIso = function (x, y) {
    return {
        x: (x + y - this.height) / 2,
        y: (x - y + this.height) / 2
    };
};

Map2d.MERGE = "merge";
Map2d.SPAWN = "spawn";
Map2d.HARVEST = "harvest";
Map2d.OPENFOG = "openfog";
Map2d.OPENDRAGON = "opendragon";
Map2d.START_MINING = "startmining";
Map2d.COMPLETE_MINING = "completemining";
Map2d.REMOVED_MINING = "removemining";
Map2d.MINE = "mine";
Map2d.START_BUILDING = "startbuilding";
Map2d.BUILD = "build";
Map2d.SPEED_UP = "speedup";
Map2d.PRIZE_HARVESTED = "prizeharvested";
Map2d.BUY_FREE_UNIT = "buyfreeunit";
Map2d.CLICK_UNIT = "clickunit";
Map2d.OPENCHEST = "openchest";
Map2d.MISSION_TREE_CLOSED = "missiontreeclosed";
Map2d.RUDOLF_COMPLETED = "rudolfcompleted";
Map2d.DRAG = "drag";
Map2d.FIELD_HARVEST = "field_harvest";
Map2d.FIELD_PLANT = "field_plant";
Map2d.COMPLETE_ORDER = "complete_order";
Map2d.FINISH_QUEST = "finish_quest";
Map2d.OPEN_UNIT = "open_unit";
Map2d.COLLECT_PIXEL = "collect_pixel";
Map2d.USE_UP_INSTANT_WORKER = "use_up_instant_worker";
Map2d.FEED_HERO = "feed_hero";
Map2d.REFILL = "refill";
Map2d.FACTORY_SPEEDUP = "factory_speedup";
Map2d.BEFORE_EXCHANGE = "before_exchange";
Map2d.EXCHANGE = "exchange";
Map2d.FORCE = "force";
Map2d.CLOSE_WINDOWS = "close_windows";
Map2d.RECIPE_READY = "recipe_ready";
Map2d.RECIPE_NEW = "recipe_new";
Map2d.RECIPE_CHANGE = "recipe_change_ingredients";

Map2d.TILE_MATERIALS = {};

Map2d.FOGS_UNITS_ONE_LAYER = true;

if (cleverapps.config.name === "wordsoup") {
    Map2d.FOGS_UNITS_ONE_LAYER = false;
}
